import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickDelete } from "../types";
import { getApi } from "../apiPath";
import { axiosClient, queryClient } from "../clients";

import type { IFaculties } from "./routeType";
import { useGetAllFaculties } from "./getAll";

const { getPath } = getApi("faculties.delete");

type IExtractedRouteType = IFaculties["facultySingleDelete"];

export type IDeleteFaculty = IPickDelete<IExtractedRouteType>;

const deleteFaculty: MutationFunction<
  IDeleteFaculty["response"],
  IDeleteFaculty["variables"]
> = ({ facultyId }) => {
  return axiosClient.delete(getPath({ facultyId }));
};

export const useDeleteFaculty = createMutation({
  mutationFn: deleteFaculty,
  onSuccess: (_) => {
    queryClient.invalidateQueries({ queryKey: useGetAllFaculties.getKey() });
  },
});
